import React, { Component } from 'react';
import { withNamespaces } from "react-i18next";
import { formValidation, clearFormValidation } from "../../hoc/Shared/utility";
import { Icon } from '@iconify/react';
// import { default as ReactSelect } from "react-select";

//Miscellaneous
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";

import MobileCommisionSimulator from "./MobileCommisionSimulator";

// const options = [
//   { value: "game0", label: "Select a Game Venue" },
//   { value: "game1", label: "Game One" },
//   { value: "game2", label: "Game Two" },
// ];

class CommisionSimulator extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = 
        {
            payout: '',
            comm_percentage: 0, // for upline own member calculation
            downline_comm_percentage: 0, // for downline own member calculation
            level_comm_percentage: 10, // upline > downline, default is 10%
            exchange_rate: 4.5, // sample fixed usd to myr exchange rate
            total_win_lose: '',
            downline_total_win_lose: '',
            active_member: false
        };
        this.onInputChangeHandler = this.onInputChangeHandler.bind(this);
    }

    componentDidMount() 
    {
        formValidation('comm_form');
    }

    onInputChangeHandler = (event) => 
    {
        // console.log(event.target.id+' | '+event.target.value);
        let uplineAmount = event.target.id === 'total_win_lose' ? event.target.value : this.state.total_win_lose;
        let downlineAmount = event.target.id === 'downline_total_win_lose' ? event.target.value : this.state.downline_total_win_lose;
        let active_member = event.target.id === 'min_member' ? event.target.checked : this.state.active_member;
        let comm_percentage = this.state.comm_percentage;
        let downline_comm_percentage = this.state.downline_comm_percentage;
        const commision = this.props.data;

        for (const item of commision) {
            let min = parseFloat(item.min);
            let max = parseFloat(item.max);
            if (item.operation == 'any') {
                comm_percentage = item.percentage;
                downline_comm_percentage = item.percentage;
            } else if (item.operation == 'between') {
                if (uplineAmount >= min && uplineAmount <= max && active_member) {
                    comm_percentage = item.percentage;
                }
                if (downlineAmount >= min && downlineAmount <= max && active_member) {
                    downline_comm_percentage = item.percentage;
                }
            } else if (item.operation == 'less or greater than') {
                if ((uplineAmount < min || uplineAmount >= max) && active_member) {
                    comm_percentage = item.percentage;
                }
                if ((downlineAmount < min || downlineAmount >= max) && active_member) {
                    downline_comm_percentage = item.percentage;
                }
            }
        }

        this.setState({
            [event.target.name]: event.target.value,
            comm_percentage,
            downline_comm_percentage,
            active_member,
            payout: ''
        });
    }

    submitHandler = (e) => 
    {
        // console.log("submitHandler :", this.state);
        e.preventDefault();
        let totalWinLose = parseFloat(this.state.total_win_lose);
        let downlineTotalWinLose = parseFloat(this.state.downline_total_win_lose);
        let commPercentage = parseFloat(this.state.comm_percentage);
        let downlineCommPercentage = parseFloat(this.state.downline_comm_percentage);
        let levelCommPercentage = this.state.level_comm_percentage;

        let payout = (totalWinLose * commPercentage) / 100;
        let downlinePayout = (downlineTotalWinLose * downlineCommPercentage) / 100;
        payout += ((downlinePayout * levelCommPercentage) / 100);
        payout = (payout * this.state.exchange_rate).toFixed(2);

        this.setState({
            payout,
        });
    };
    
    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item, index) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        const { t } = this.props;
        // const icons = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));
        // const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));

        return (
            <Auxiliary>
                {isDesktop ? (
                    <div className="quota-deposit-container">
                        <div className="row g-3">
                            <div className="col-6">
                                <form className="forms-col needs-validation" method="post" id="comm_form" onSubmit={this.submitHandler} noValidate>
                                    <div>
                                        <label>
                                            <span className="text-danger">*</span> {t('commission-illustrate.total-win-lose')} (USD)
                                        </label>
                                        <div className="input-group right has-validation">
                                            <NumberInput
                                                className="form-control"
                                                onChange={(event) => this.onInputChangeHandler(event)}
                                                name="total_win_lose"
                                                id="total_win_lose"
                                                value={this.state.total_win_lose}
                                                required={true}
                                                requiredMessage={t("validation.required")}
                                                placeholder={t('commission-illustrate.total-win-lose')}
                                                // formError={this.state.formError}
                                                // errorMsg={this.state.errorMsg.bank_acc_number || ""}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label>
                                            <span className="text-danger">*</span> {t('commission-illustrate.downline-total-win-lose')} (USD)
                                        </label>
                                        <div className="input-group right has-validation">
                                            <NumberInput
                                                className="form-control"
                                                placeholder={t('commission-illustrate.downline-total-win-lose')}
                                                onChange={(event) => this.onInputChangeHandler(event)}
                                                name="downline_total_win_lose"
                                                id="downline_total_win_lose"
                                                value={this.state.downline_total_win_lose}
                                                required={true}
                                                requiredMessage={t("validation.required")}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label>
                                            {t('commission-illustrate.min-active-member')}
                                            <input
                                                id="min_member"
                                                name="min_member"
                                                style={{marginLeft: '2px'}}
                                                className="form-check-input"
                                                onChange={(event) => this.onInputChangeHandler(event)}
                                                type="checkbox"
                                                onClick={(event)=>event.stopPropagation()}
                                            />
                                        </label>
                                    </div>
                                    {/* <div>
                                        <label>
                                            <span className="text-danger">*</span> Member Gaming Venues
                                        </label>
                                        <div className="input-group has-validation">
                                            <ReactSelect
                                                classNamePrefix="react-select"
                                                defaultValue={options[0]}
                                                // value={this.props.selectedOption}
                                                onChange={this.props.handleChange}
                                                options={options}
                                            />
                                        </div>
                                    </div> */}
                                    <div>
                                        <label>
                                            {t('commission-illustrate.commission-percentage')}
                                        </label>
                                        <div className="input-group right has-validation">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={`${this.state.comm_percentage}%`}
                                                readOnly
                                                // placeholder=""
                                                // onChange={(e) => this.insertCommission(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <label>
                                            {t('commission-illustrate.commission')} ({this.props.currentUser.data.currency})
                                        </label>
                                        <div className="input-group right has-validation">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.payout}
                                                readOnly
                                                // placeholder=""
                                                // onChange={(e) => this.insertCommission(e)}
                                            />
                                        </div>
                                        {this.state.payout !== '' &&
                                        <small style={{color: 'red', fontSize: '10px'}}>
                                            {t('commission-illustrate.sample-calculation')}: (({this.state.total_win_lose} * {this.state.comm_percentage}%) + (({this.state.downline_total_win_lose} * {this.state.downline_comm_percentage}%) * {this.state.level_comm_percentage}%)) * {this.state.exchange_rate}
                                        </small>
                                        }
                                    </div>
                                    <button type="submit" className="btn btn-gradient-blue w-50">
                                        {t('global.submit')}
                                    </button>
                                </form>
                                <div className="content-wrap" >
                                    <p className="text-danger"><Icon icon="akar-icons:circle-alert-fill" /> {t('commission-illustrate.agent-comm-notice-7', {exchange_rate: this.state.exchange_rate})}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <MobileCommisionSimulator
                        {...this.state}
                        currentUser={this.props.currentUser.data}
                        onInputChangeHandler={this.onInputChangeHandler}
                        submitHandler={this.submitHandler}
                    />
                )}
            </Auxiliary>
        )
    }
}

export default withNamespaces("translation")(CommisionSimulator);